import React from 'react';

import Icon from './Icon';
import { useTheme } from '../../hooks/useTheme';

/**
 * Sun/moon switch for the top nav.
 *
 * Deliberately neutral chrome, not an AI action - the purple accent is
 * reserved for AI activity, so this button stays on the neutral tokens and
 * only its icon changes between themes.
 */
function ThemeToggle({ className = '' }) {
  const { isDark, toggleTheme } = useTheme();
  const label = isDark ? 'Switch to light theme' : 'Switch to dark theme';

  return (
    <button
      type="button"
      className={`topbar-icon-button theme-toggle ${className}`.trim()}
      onClick={toggleTheme}
      aria-label={label}
      title={label}
    >
      <Icon name={isDark ? 'sun' : 'moon'} />
    </button>
  );
}

export default ThemeToggle;
